
// src/api/services/user.js
import apiClient from '../client';

export const userService = {
    getProfile: () => apiClient.get('/api/user/profile'),
    updateProfile: (data) => apiClient.put('/api/user/profile', data),
    getCredits: () => apiClient.get('/api/user/credits'),
    buyCredits: (amount) => apiClient.post('/api/user/credits', { amount }),
    getSubscription: () => apiClient.get('/api/user/subscription'),
    updateSubscription: (data) => apiClient.put('/api/user/subscription', data),
    cancelSubscription: () => apiClient.delete('/api/user/subscription'),
};